<template>
  <el-dialog
    class="dialog-wrapper roles-modal"
    :visible="visible"
    :show-close="false"
    @close="abortAction"
  >
    <ContentHeader
      slot="title"
      :title="$t('operations.copyTo.copyOperation')"
    />

    <el-form
      class="operations-search-form"
      size="small"
      label-position="top"
    >
      <el-row
        :gutter="20"
        type="flex"
      >
        <el-col :span="12">
          <el-form-item>
            <span slot="label">{{ $t('operations.search.description') }}</span>
            <el-autocomplete
              v-model="formData.description"
              value-key="label"
              clearable
              class="width-100"
              :fetch-suggestions="
                (text, cb) => {
                  searchAnalyses({ text, cb, field: 'description' });
                }
              "
              :trigger-on-focus="false"
              :disabled="formData.code !== ''"
              @select="selectAnalysis"
              @change="emptySelectedAnalysis"
            >
              <template slot-scope="{ item }">
                <AutocompleteItem :item="item" />
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item>
            <span slot="label">{{ $t('operations.search.code') }}</span>
            <el-autocomplete
              v-model="formData.code"
              value-key="label"
              clearable
              class="width-100"
              :fetch-suggestions="
                (text, cb) => {
                  searchAnalyses({ text, cb, field: 'code' });
                }
              "
              :trigger-on-focus="false"
              :disabled="formData.description !== ''"
              @select="selectAnalysis"
              @change="emptySelectedAnalysis"
            >
              <template slot-scope="{ item }">
                <AutocompleteItem :item="item" />
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>

      <FormButtons>
        <el-button
          type="secondary"
          @click.prevent="abortAction"
        >
          {{ $t('operations.copyTo.abortAction') }}
        </el-button>
        <el-button
          type="primary"
          :disabled="formData.analysisId == null"
          @click.prevent="checkOperationsSequence"
        >
          {{ $t('operations.copyTo.confirmAction') }}
        </el-button>
      </FormButtons>
    </el-form>
  </el-dialog>
</template>

<script>
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';
  import AutocompleteItem from '@/components/AutocompleteItem.vue';
  import { analysesApi } from '@/api';

  const initialFormData = {
    description: '',
    code: '',
    analysisId: null,
  };

  export default {
    name: 'CopyOperations',
    components: {
      ContentHeader,
      FormButtons,
      AutocompleteItem,
    },
    props: {
      visible: { type: Boolean, default: false },
      selectedOperations: { type: Array, default: () => [] },
    },
    data() {
      return {
        formData: { ...initialFormData },
        analysisOperations: [],
      };
    },
    methods: {
      async searchAnalyses({ text, cb, field }) {
        if (text.length >= 3) {
          const response = await analysesApi.autocompleteFetch(field, text);
          const analyses = response.data.map((a) => ({
            value: a.id,
            label: a[field],
          }));
          cb(analyses);
        } else {
          cb([]);
        }
      },
      async copyOperations() {
        try {
          const sourceOperations = this.selectedOperations.map((o) => o.id);
          await analysesApi.operationsCopy(
            this.formData.analysisId,
            sourceOperations
          );
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('operations.copyTo.success'),
          });
          this.$emit('dialogClose', {
            success: true,
            formData: this.formData,
          });
          this.formData = { ...initialFormData };
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
      async getOperations(analysisId) {
        const operations = await analysesApi.operationsInAnalysis(analysisId);
        this.analysisOperations = operations.data ?? [];
      },
      selectAnalysis(item) {
        this.formData.analysisId = item.value;
        this.getOperations(item.value);
      },
      emptySelectedAnalysis(text) {
        if (text === '') {
          this.formData.analysisId = null;
          this.analysisOperations = [];
        }
      },
      abortAction() {
        this.formData = { ...initialFormData };
        this.$emit('dialogClose', { success: false });
      },
      checkOperationsSequence() {
        const duplicatedOperationsSequence = this.analysisOperations.filter(
          (aop) =>
            this.selectedOperations.filter(
              (sop) => aop.sequence === sop.sequence
            )
        );
        if (duplicatedOperationsSequence.length > 0) {
          this.$confirm(
            this.$t('operations.copyTo.duplicateSequenceMessage'),
            this.$t('global.warning'),
            {
              confirmButtonText: this.$t('global.confirm'),
              cancelButtonText: this.$t('global.cancel'),
            }
          )
            .then(() => {
              return this.copyOperations();
            })
            .catch(() => {
              this.$emit('dialogClose', {
                success: false,
              });
            });
        } else {
          this.copyOperations();
        }
      },
    },
  };
</script>
